/*eslint-disable */

import DashSidebar from '@/components/private/common/dashboard-left-sidebar/';
import Push from 'push.js';
import {
  bus
} from '@/main';
import chatbot from '@/components/private/ai-chatbot/';
import commonSocket from '@/commonSocket/';
import {
  mapGetters
} from 'vuex';
import moment from 'moment';
import networkIssuePopup from '@/components/common/network-issue-popup/';
import videoCallNotification from '@/components/private/video-call-notification-popup/';

const $ = window.jQuery = require('jquery');
var schedulerPushNotification;
export default {
  name: 'dashboard',
  components: {
    'user-chatbot' : chatbot,
    'dash-sidebar' : DashSidebar,
    'video-call' : videoCallNotification,
    networkIssuePopup
  },
  props: [],
  data () {
    return {
      userDetails:null,
      incomingCallNotification:false,
      selfUserId: '',
      videoCallerUserId:'',
      requestMemberInfo:null,
      isMobile:false,
      audioPlayer:null,
      roomId:'',
      callerInfo:null,
    }
  },
  computed: {
    ...mapGetters([
      'acUserDetailsStateGetters'
    ]),
    userDetailsData() {
      this.userDetails = this.$store.getters.acUserDetailsStateGetters.data;
      return this.userDetails;
    },
  },
  mounted () {
    if (!localStorage.getItem('token') || !localStorage.getItem('LoginedUserID')) {
      this.$router.push('/');
    };
    
    this.selfUserId = localStorage.getItem('LoginedUserID');
    this.$store.dispatch('getAuthHeader');

    this.userDetailsData;
    this.$nextTick(() => { // Ensure the DOM is updated before emitting
      bus.$emit('showHeaderbtn', true);
      $(".preloader").delay(200).fadeOut("slow");
    });
    Push.Permission.request(this.onGranted(), this.onDenied());
  
    if (this.$route.name !== 'videoConferenceMain' && this.$route.name !== 'videoCallOneToOnePeer') {
      setTimeout(() => {
        this.commonSocketConnectMethod();
      }, 800);
    }
    
    bus.$on('callerNotifiactionBus', (data) => {
      this.incomingCallNotification = data;
    });

    bus.$on('sendRequestMessage', (data) => {
      const payload = {
        message: "Friend Request",
        type: "friendRequest",
        userID: data.to_user,
        fromUserID: data.from_user,
        second_user_id:data.to_user,
      };
      commonSocket.emit(payload);
    });

    bus.$on('newChatMessage', (data) => {
      const payload = {
        type: "newChatMessage",
        chatRoomId: data.chatRoomId,
        message: data.message,
        senderName: data.senderName
      };
      commonSocket.emit(payload);
    });
    
  },
  methods: {
    onGranted() {
      Push.Permission.GRANTED;
    },
    onDenied() {
      Push.Permission.DENIED;
    },
    onResize() {
      this.isMobile = window.innerWidth < 769
    },
    schedulerIsReadStatusUpdateMethod(schedulerId){
      var data = {
        is_read:true
      }
      this.$store.dispatch('updateSchedulerDetailsAction', {data:{data:data,id:schedulerId}})
    },
    getBrowserVersion() {
        var ua= navigator.userAgent, tem,
        M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if(/trident/i.test(M[1])){
            tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
            return 'IE '+(tem[1] || '');
        }
        if(M[1]=== 'Chrome'){
            tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
            if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
        }
        M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
        if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
        return M[1];
    },
    playSound (sound) {
      if(sound) {
        this.audioPlayer = new Audio(sound);
        this.audioPlayer.play();
      }
    },
    stopSound () {
      if(this.audioPlayer == null) return;  
      this.audioPlayer.muted = true;
      this.audioPlayer.pause();
      this.audioPlayer.currentTime = 0;
      this.audioPlayer = null
    },
    commonSocketConnectMethod(){
      let callerID = '3548d149becb44e9';
      commonSocket.connect(callerID);
      commonSocket.$on('connection', response => {
        const payload = {
          type: "userStatus",
          userID: this.selfUserId,
        };
        commonSocket.emit(payload);
      });
      commonSocket.$on('userLogin', this.handleUserLogin);
      commonSocket.$on('userStatus', this.handleSelfUserStatus);
      commonSocket.$on('selfUserStatus', this.handleAllUserStatus);
      commonSocket.$on('TypingEventForSelectedUserNotification', this.handleTypingEventNotification)
      commonSocket.$on('videoCallingNotification', this.handleVideoCallMethod);
      commonSocket.$on('videoCallAlertPopupClosed', this.callerPopupClosedInOtherTabs);
      commonSocket.$on('friendRequest', this.handleFriendRequest);
      commonSocket.$on('newMessageNotifications', this.handleNewMessageNotification);
      commonSocket.$on('messageForwardedOfUsersNotification', this.handleMessageForwardedOfUsersNotification);
      commonSocket.$on('userLogout', this.handleUserLogout);
    },
    handleMessageForwardedOfUsersNotification(response) {
      const toUserID = response.toUserID;
      if(toUserID == this.selfUserId) return;
      try {
        const payload = {
          chat_data: response.chat_data,
          toUserID: response.toUserID,
          targetUsersID:response.targetUsersID,
          colour:response.colour,
          message_id_arr:response.message_id_arr,
        };
        bus.$emit('forwardedMessageNotifications', payload);
      } catch(e) {
        console.log(e);
      }
    },
    handleNewMessageNotification(response) {
        bus.$emit('updateMessageNotification', response);
        bus.$emit('updateMessageNotifications', response);
    },
    handleVideoCallMethod(getData){
      if(this.selfUserId == getData.targetId){
        if(Push.Permission.has()){
          Push.create('Lymphomap Video Call From ' + getData.callerName, {
            body:'Check Your lymphomap to answer',
            timeout:5000,
            onClick: function () {
                window.focus();
                this.close();
            }
          })
        }
        document.body.classList.add('videoNotificationPopup');
        this.callerInfo = getData
        this.roomId = getData.roomId;
        this.incomingCallNotification = true
        // this.playSound(audioPlay)
      }
    },
    callerPopupClosedInOtherTabs(closeOtherTabData){
      if(this.selfUserId != closeOtherTabData.videoCallRoomId) return;
      if(closeOtherTabData.type == 'videoAlertPopupClose'){
        this.stopSound()
        document.body.classList.remove('videoNotificationPopup');
        this.callerInfo = null;
        this.incomingCallNotification = false
      }
    },
    closeSocketMethod() {
      if(commonSocket.isOpen()) {
        commonSocket.close();
      }
    },
    handleFriendRequest(response) {
      const userID = response.userID;
      const fromUserID = response.fromUserID;
      if(fromUserID == this.selfUserId || userID != this.selfUserId) return;
      try {
        const payload = {
          userID
        };
        bus.$emit('userFriendRequest', payload);
      } catch(e) {
        console.log(e);
      }
    },
    handleUserLogout(response) {
      try {
        const payload = {
          userID: response.userID,
          is_online: false,
        };
        bus.$emit('userUpdateStatus', payload);
      } catch(e) {
        console.log(e);
      }
    },
    handleUserLogin(response) {
      try {
        const payload = {
          userID: response.userID,
          is_online: true,
        };
        bus.$emit('userUpdateStatus', payload);
      } catch(e) {
        console.log(e);
      }
    },
    handleSelfUserStatus(response) {
      try {
        const payload = {
          userID: response.userID,
          is_online: true,
          totalUnreadCount: response.totalUnreadCount,
          connectionRequestCount: response.connection_request_count,
          supportUnreadCount: response.supportUnreadCount,
          notificationUnreadCount: response.notificationUnreadCount,
        };
        bus.$emit('selfUserUpdateStatus', payload);
      } catch(e) {
        console.log(e);
      }
    },
    handleTypingEventNotification(response){
      bus.$emit('typingEventForChatBus', response);
    },
    handleAllUserStatus(response) {
      const userID = response.userID;
      if(userID == this.selfUserId) return;
      try {
        const payload = {
          userID: response.userID,
          current_status:response.current_status,
          status_time:response.status_time
        };
        bus.$emit('userSelfStatus', payload);
      } catch(e) {
        console.log(e);
      }
    },
  },
  watch:{
    userDetailsData(){
      return this.$store.getters.acUserDetailsStateGetters.data;
    },
  },
  beforeMount() {
    window.addEventListener("beforeunload", this.closeSocketMethod)
  },
  beforeDestroy() {
    if(commonSocket.isOpen()) {
      commonSocket.close();
    }
    window.removeEventListener("beforeunload", this.closeSocketMethod);
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true });
    }
  },
  created () {
    window.addEventListener('resize', this.onResize, { passive: true });
    this.onResize();
  },
  beforeCreate: function() {
    document.body.classList.add('dashboard');
    document.body.classList.add('sidebar_collapsed');
    document.body.classList.remove('videoNotificationPopup');
  },
  beforeRouteLeave: function(to, from, next) {
    this.stopSound();
    if(commonSocket.isOpen()) {
      commonSocket.close();
    }
    document.body.classList.remove('dashboard');
    document.body.classList.remove('videoNotificationPopup');
    clearInterval(schedulerPushNotification);
    next();
  },
}
